<!--
    组织机构多选下拉框
    api: orgsChange 值变化后的回调函数，返回id数组
-->

<template>
    <el-form-item :label="label || $t('c.belong')" :prop="prop">
        <el-popover
            placement="bottom"
            width="240"
            trigger="click">
            <el-tree
                ref="tree"
                class="org-tree"
                :data="orgTree"
                :props="defaultProps"
                :check-strictly="true"
                show-checkbox
                node-key="id"
                :default-expanded-keys="defaultExpandKeys"
                :default-checked-keys="defaultCheckedKeys"
                @check-change="checkChange"
                :getCheckedNodes="name"
                :render-after-expand="renderAfterExpand"
                :render-content="renderContent">
            </el-tree>
            <el-input slot="reference" v-model="name" class="multi-org-input"
                      :placeholder="$t('tip.select')+(label || ' '+$t('c.belong'))"
                      readonly="readonly"
            >
                <template #append>
                    <slot name="append"></slot>
                </template>
            </el-input>
        </el-popover>

    </el-form-item>
</template>

<script>
    import {mapGetters} from 'vuex';

    /**
     * 0、这个组件的设计初衷：
     *      需求想要父节点可以单独被选，这个组件大部分逻辑是用来处理“选父会影响子”，但“选子不影响父”的逻辑。
     *      后来el-tree的check-strictly参数支持了父子之间严格互不关联，所以我又加了个single参数来控制。
     *
     * 1、props参数说明（均非必须）：
     *      title: 字段名称，默认为“所属机构”
     *      prop: 需要做表单验证时传入
     *      defaultCheckedKeys：默认选中的节点
     *      single: 默认false，即选父会把子勾上，但选子不影响父；设为true时严格的互不影响
     *
     * 2、注意render-after-expand属性，是否在第一次展开某个树节点后才渲染其子节点，默认为true
     *    但是为true的时候，没展开过的父节点触发checkChange，因子节点还没渲染，所以checkChange只会触发一次（父节点这次）
     *    所以在这里要设为false（要拿到数据之后设为false，不然会没数据）
     *
     * 3、2020/9/18 更新
     *    支持使用v-model绑定值。之前用"orgsChange"绑定值的方式已不再推荐
     */
    export default {
        props: {
            value: {},
            label: String,
            prop: {
                type: String,
                default: null
            },
            /**
             *  本来支持了v-model后，直接用传过来的value就可以进行初始化
             *  但是这会影响到父子之间的关联逻辑，故保留该选项
             */
            defaultCheckedKeys: {
                type: Array,
                default: () => {
                    return []
                }
            },
            single: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                orgTree: [],
                orgIds: [],
                name: '',
                defaultExpandKeys: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                renderAfterExpand: true,
            }
        },

        created() {
            this.$store.dispatch('getOrgTree').then(data => {
                this.orgTree = data

                data.forEach(v => {
                    if (v.children.length) {
                        this.defaultExpandKeys.push(v.id);
                    }
                });
                this.renderAfterExpand = false;

                this.$nextTick(() => {
                    // 文本溢出显示title
                    $('.org-tree').on('mouseenter', '.org-name', function () {
                        let width = this.clientWidth;
                        let fullWidth = this.scrollWidth;

                        if (width < fullWidth) {
                            $(this).attr('title', $(this).text())
                        } else {
                            $(this).removeAttr('title')
                        }
                    })
                });
            })
        },

        computed: {
            // ...mapGetters([
            //     'orgTree',
            // ])
        },

        watch: {
            value(v) {
                if (!v.length) {
                    this.defaultCheckedKeys = []
                }
            }
        },

        methods: {
            renderContent(h, {node, data, store}) {
                return (
                    <span class="org-name" style="font-size: 14px;"> {node.label}</span>
                );
            },
            checkChange (val, checked, nodeChecked) {
                let that = this;
                let checkArr = this.$refs.tree.getCheckedKeys()
                this.orgIds = this.deleteSame(checkArr);
                // emit
                this.$emit('orgsChange', this.orgIds);
                this.$emit('change', this.orgIds);
                this.$emit('input', this.orgIds);

                if (this.single)  {
                    this.name = this.$refs.tree.getCheckedNodes().map(node => node.name).join(', ')
                    return
                }

                iterator(this.orgTree)
                function iterator(data) {
                    data.forEach(item => {
                        if (item.children) {
                            if (item.id === val.id && checked) {
                                let ids = that.getIds(item)

                                checkArr.push(...ids)
                            } else if (item.id === val.id && !checked) {
                                let ids = that.getIds(item)
                                let checkSet = new Set(checkArr)

                                ids.forEach(id => {
                                    checkSet.delete(id)
                                })
                                checkArr = [...checkSet]
                            } else {
                                iterator(item.children)
                            }
                        }
                    })
                }

                checkArr = Array.from(new Set(checkArr))
                this.$refs.tree.setCheckedKeys(checkArr)
                this.name = this.$refs.tree.getCheckedNodes().map(node => node.name).join(', ')
            },
            deleteSame(array){
                let r = [];
                for (let i = 0, l = array.length; i < l; i++) {
                    for (let j = i + 1; j < l; j++)
                        if (array[i] === array[j]) j = ++i;
                    r.push(array[i]);
                }
                return r;
            },
            getIds (data) {
                let that = this
                function getChildids(arr) {
                    let idsArr = []
                    arr.forEach(item => {
                        if (item.children) {
                            idsArr.push(item.id)
                            idsArr = idsArr.concat(getChildids(item.children))
                        } else {
                            idsArr.push(item.id)
                        }
                    })
                    return idsArr
                }

                function getIds(data) {
                    let ids = [data.id]
                    ids = ids.concat(getChildids(data.children))
                    return ids
                }

                return getIds(data)
            },
            resetChecked() {
                this.$refs.tree.setCheckedKeys([]);
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../style/const.scss';

    .org-tree {
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;

        /deep/ .org-name {
            @include no-wrap;
        }
    }

</style>
